module.exports = __webpack_public_path__ + "img/archived.6f1fe4f2.svg";